import { Card } from "src/lib/components/basics"

const Root = (props: any) => {
    return (
        <Card sx={{padding: 3}} {...props}>
            {props.children}
        </Card>
    )
}

export {Root}